import { ReactNode } from 'react';

import styles from './SaleDetails.scss';

export const SaleDetailsItem = ({ amount, label }: { amount: ReactNode; label: ReactNode }) =>
  <>
    <span>{label}</span>
    <span className={styles.amountCell}>{amount}</span>
  </>;
